import React from 'react'
import { RiVipCrownFill } from 'react-icons/ri'
import { useSelector } from 'react-redux'

import { Button, Progress } from 'components/ui'
import BillingForm from './BillingForm'
import BillingPackages from './BillingPackages'
import { GrClose } from 'react-icons/gr'
import { AiOutlineCheck } from 'react-icons/ai'
import TitlesProgress from '../SearchTitlesFeed/TitlesProgress'

const FeedSummary = React.memo(
    ({ packages, selectedPackage, setSelectedPackage }) => {
        const { premiumTitlesCount, standardTitlesCount } = useSelector(
            (state) => state.checkout.titles
        )
        const subscription = useSelector(
            (state) => state.base.common.subscription
        )
        const { changePackageTo } = useSelector(
            (state) => state.checkout.selectPlan
        )

        return (
            selectedPackage && (
                <div className="flex flex-col gap-8">
                    <div>
                        <h5>Title Feed Summary</h5>
                        <div className="my-4 p-5 border bg-white">
                            <div className="font-medium text-black text-base">
                                Please select a plan
                            </div>
                            <div className="my-0 flex flex-col gap-3 bg-white py-5 rounded-md ">
                                <TitlesProgress cartView={true} />
                            </div>
                        </div>
                    </div>

                    {changePackageTo?.id ? (
                        <div>
                            <h5 className="mb-4">
                                Your subscription will be changed to the
                                following package.
                            </h5>
                            <div className="flex">
                                <div className="flex-none">
                                    <div className="p-4 border border-b-0 border-r-0 h-16"></div>
                                    <div className="p-4 border border-b-0 border-r-0 h-16 justify-center flex items-center">
                                        <div className="justify-center flex items-center">
                                            <RiVipCrownFill className="text-lg text-blue-600" />
                                            <span className="mx-2 font-medium text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-cyan-400">
                                                Premium
                                            </span>
                                        </div>
                                    </div>
                                    <div className="p-4 border border-b-0 border-r-0 h-16 justify-center flex items-center">
                                        <span className="font-medium text-cyan-500">
                                            Standard
                                        </span>
                                    </div>
                                    <div className="p-4 border border-b-0 border-r-0 h-16 justify-center flex items-center text-gray-700">
                                        Support
                                    </div>
                                    <div className="p-4 border border-b-0 border-r-0 h-16 justify-center flex items-center"></div>
                                </div>
                                <div
                                    key={changePackageTo.id}
                                    className={`flex-none flex flex-col text-center text-gray-700 border border-stone-400`}
                                >
                                    <div
                                        className={`p-4 border border-b-0  h-16 justify-center flex flex-col items-center gap-1 border-r-0`}
                                    >
                                        <div className="font-medium text-black">
                                            {changePackageTo.title}
                                        </div>
                                        <div>
                                            $
                                            {changePackageTo.price.toLocaleString()}
                                            /mo
                                        </div>
                                    </div>
                                    <div
                                        className={`p-4 border border-b-0  h-16 justify-center flex items-center line-clamp-2 border-r-0`}
                                    >
                                        {changePackageTo.premium_num}
                                    </div>
                                    <div
                                        className={`p-4 border border-b-0  h-16 justify-center flex items-center line-clamp-2 border-r-0`}
                                    >
                                        {changePackageTo.standard_num}
                                    </div>
                                    <div
                                        className={`p-4 border border-b-0  h-16 justify-center flex items-center  border-r-0`}
                                    >
                                        {changePackageTo.premium_num < 5000 ? (
                                            <GrClose />
                                        ) : (
                                            <div className="flex items-center gap-0 text-green-500">
                                                <AiOutlineCheck />
                                                <span className="text-xs">
                                                    Dedicated CS
                                                </span>
                                            </div>
                                        )}
                                    </div>
                                    <div
                                        className={`p-4 border border-b-0  h-16 justify-center flex items-center border-r-0`}
                                    >
                                        <Button
                                            variant="solid"
                                            disabled={true}
                                            // onClick={() => false}
                                        >
                                            {'Selected'}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <BillingPackages
                            packages={packages}
                            selectedPackage={selectedPackage}
                            setSelectedPackage={setSelectedPackage}
                        />
                    )}

                    {/* <div className="pb-10">
                        <h5>Billing Details</h5>
                        <div className="my-4 p-5 border bg-white">
                            <BillingForm />
                        </div>
                    </div> */}
                </div>
            )
        )
    }
)

export default FeedSummary
